/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './post.defs.js'
export { main as default } from './post.defs.js'
